import React from 'react';
import styled from 'styled-components';

import BreadCrumbs from '@/components/atom/BreadCrumbs';
import PaginationComponent from '@/components/common/PaginationComponent';
import ListMagazineLine from '@/components/common/communication/magazine/ListMagazineLine';
import LinkTag from '@/components/common/link-tag';
import TemplateLayout from '@/components/layouts/TemplateLayout';
import StickyAppHeader from '@/components/molecules/sticky-app-header';
import useFaqViewModel from '@/hooks/faq/useFaqViewModel';
import { Tablet } from '@/styles/layout';
import theme from '@/styles/theme';
import { ClientType, CustomPageProps } from '@/types/app';
import { ROUTES } from '@/types/common';

interface Props extends CustomPageProps {
  viewModel: useFaqViewModel;
}
const FaqTemplate = ({ client, viewModel }: Props) => {
  return (
    <TemplateLayout.Wrapper>
      {client.isWebView && (
        <TemplateLayout.Header useSafeArea>
          <StickyAppHeader title='건강 매거진' />
        </TemplateLayout.Header>
      )}
      <TemplateLayout.Content>
        <Wrapper>
          {client.clientType === ClientType.WEB && (
            <BreadCrumbsWrapper>
              <BreadCrumbs visible name='1분 FAQ' type='faq' path={`${ROUTES.FAQ.LIST.path}`} />
            </BreadCrumbsWrapper>
          )}
          <Content>
            <PageTile>1분 FAQ</PageTile>
            {viewModel.faqs && (
              <List>
                {viewModel.faqs.map((faq) => (
                  <LinkTag
                    key={faq.magazinePid}
                    href={`${ROUTES.FAQ.DETAIL.path}/${faq.magazinePid}`}
                    onClickNavigateToScreen={() => viewModel.onClickFaqDetail(faq.magazinePid)}
                  >
                    <ListMagazineLine
                      magazine={{
                        title: faq.title,
                        mobileTitle: faq.title,
                        image: '',
                        date: faq.date,
                        magazinePid: faq.magazinePid,
                        description: faq.description,
                        mobileDescription: faq.description,
                        siteName: faq.siteName,
                      }}
                    />
                  </LinkTag>
                ))}
              </List>
            )}
            <PaginationComponent
              totalPage={viewModel.totalPage}
              currentPage={Number(viewModel.queries.page)}
              baseUrl={`${ROUTES.FAQ.LIST.path}`}
              scroll={false}
            />
          </Content>
        </Wrapper>
      </TemplateLayout.Content>
    </TemplateLayout.Wrapper>
  );
};
export default FaqTemplate;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${({ theme }) => theme.color.white};
`;

const BreadCrumbsWrapper = styled(BreadCrumbs.Wrapper)``;

const Content = styled.main`
  display: flex;
  width: 100%;
  max-width: 1152px;
  flex-direction: column;
  padding-bottom: 24px;
`;

const PageTile = styled.h1`
  padding: 16px 24px 8px 24px;
  color: ${theme.color.gray700};
  ${theme.typography.UI28SB};

  @media screen and (max-width: ${Tablet}) {
    ${theme.typography.UI22SB};
  }
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  * > li {
    list-style: none;
  }
`;
